export default {
taskRecord: {
  title: "Hadiah Tugas",
  loading: "Memuat...",
  empty: "Tidak ada hadiah",
  completed: "Tugas telah selesai",
  desc: "Selesaikan tugas untuk mendapatkan hadiah",
  close: "Tutup",
  add: "Tambah",
  addEmail: "Tambah Email",
  addPhoneNumber: "Tambah Nomor Telepon",
  addBirthday: "Tambah Tanggal Lahir",
  downloadNow: "Unduh Sekarang",
  phone: "Nomor telepon",
  email: "Alamat email",
  bank: "Kartu bank",
  birthday: "Tanggal lahir",
  download: "Unduh",
  downloadApp: "Unduh APP",
  registerBonus: "Bonus Registrasi",
  firstInviteBonus: "Bonus Undangan Pertama",
  invite: "Undang",
  inviteNow: "Undang Teman",
  go: "Pergi",
  receive: "Ambil",
  received: "Sudah diambil",
  task: "Tugas",
  claimRewards: 'Klaim Hadiah',
  receiveSuccess: 'Hadiah berhasil diklaim',
  receiveFail: 'Gagal mengklaim hadiah'
}
};
